const {enabled}=require('./transition.js');
const clamp=value=>Math.max(0,Math.min(1,value));
const number=value=>value.toFixed(3);
const scenes=[];
const property=(element,name,value)=>element?.style.setProperty(name,value);
const clear=(element,...names)=>names.forEach(name=>element?.style.removeProperty(name));
const content=(element,value)=>{if(element&&element.textContent!==value)element.textContent=value;};
const register=(selector,create)=>document.querySelectorAll(selector).forEach(element=>scenes.push({element,...create(element)}));
const currentIndex=rects=>Math.max(0,rects.findLastIndex(rect=>rect.top<innerHeight*.56));
const entry=rect=>clamp((innerHeight*.93-rect.top)/(innerHeight*.65));

register('[data-services-scene]',element=>{
 const items=[...element.querySelectorAll('.one-services__item')],arts=[...element.querySelectorAll('[data-service-art]')];
 const counter=element.querySelector('[data-services-current]');
 const activate=index=>{
  items.forEach((item,i)=>item.classList.toggle('is-current',i===index));
  arts.forEach((art,i)=>art.classList.toggle('is-current',i===index));
  content(counter,String(index+1).padStart(2,'0'));
 };
 return {
  read:()=>items.map(item=>item.getBoundingClientRect()),
  write:rects=>{
   if(!rects.length)return;
   const index=currentIndex(rects),fraction=clamp((innerHeight*.56-rects[index].top)/rects[index].height);
   activate(index);
   property(element,'--service-progress',number((index+fraction)/items.length));
   property(element,'--service-turn',`${number(-14+28*fraction)}deg`);
   items.forEach((item,i)=>{const progress=entry(rects[i]);property(item,'--service-fill',number(progress));property(item,'--service-lift',`${number((1-progress)*60)}px`);property(item,'--service-art-turn',`${number(-22+progress*32)}deg`);});
  },
  reset:()=>{activate(0);clear(element,'--service-progress','--service-turn');items.forEach(item=>clear(item,'--service-fill','--service-lift','--service-art-turn'));}
 };
});

register('[data-process-scene]',element=>{
 const steps=[...element.querySelectorAll('.one-process__step')],segments=[...element.querySelectorAll('.one-process__segments b')];
 const nodes=[...element.querySelectorAll('[data-process-node]')];
 const counter=element.querySelector('[data-process-current]'),title=element.querySelector('[data-process-title]');
 const titles=steps.map(step=>step.querySelector('h3')?.textContent||'');
 const activate=index=>{
  steps.forEach((step,i)=>step.classList.toggle('is-current',index===i));
  nodes.forEach((node,i)=>node.classList.toggle('is-complete',i<=index));
  content(counter,String(index+1).padStart(2,'0'));
  content(title,titles[index]||'');
 };
 return {
  read:()=>steps.map(step=>step.getBoundingClientRect()),
  write:rects=>{
   if(!rects.length)return;
   const index=currentIndex(rects);
   activate(index);
   const fraction=clamp((innerHeight*.56-rects[index].top)/rects[index].height);
   property(element,'--process-route',number(clamp((index+fraction)/Math.max(1,steps.length-1))));
   rects.forEach((rect,i)=>{
    const fill=clamp((innerHeight*.56-rect.top)/rect.height);
    property(segments[i],'--segment-fill',number(fill));
    property(steps[i],'--step-fill',number(entry(rect)));
    property(steps[i],'--step-offset',`${number(20*(1-entry(rect)))}px`);
   });
   property(element,'--process-turn',`${number(-35+35*entry(rects[0]))}deg`);
  },
  reset:()=>{activate(0);clear(element,'--process-turn','--process-route');segments.forEach(segment=>clear(segment,'--segment-fill'));steps.forEach(step=>clear(step,'--step-fill','--step-offset'));}
 };
});

register('[data-manifesto-scene]',element=>{
 const quote=element.querySelector('.one-manifesto__quote'),words=[...element.querySelectorAll('[data-ink-word]')];
 return {
  read:()=>quote?.getBoundingClientRect(),
  write:rect=>{
   if(!rect)return;
   const progress=clamp((innerHeight*.85-rect.top)/(innerHeight*.45+rect.height*.25));
   words.forEach((word,i)=>property(word,'--ink-fill',`${number(clamp(progress*(words.length+2)-i)*100)}%`));
   property(element,'--seal-turn',`${number(-24+48*progress)}deg`);
  },
  reset:()=>{words.forEach(word=>clear(word,'--ink-fill'));clear(element,'--seal-turn');}
 };
});

register('[data-editorial-scene]',element=>({
 read:()=>element.getBoundingClientRect(),
 write:rect=>{const progress=entry(rect);property(element,'--editorial-inset',`${number((1-progress)*12)}%`);property(element,'--editorial-radius',`${number((1-progress)*48)}px`);},
 reset:()=>clear(element,'--editorial-inset','--editorial-radius')
}));

register('[data-gallery-scene]',element=>{
 const items=[...element.querySelectorAll('.one-projectstrip__item')],offsets=items.map(()=>0);
 return {
  // Subtract our translation so scroll measurements never feed back into themselves.
  read:()=>items.map((item,i)=>item.getBoundingClientRect().top-offsets[i]),
  write:tops=>items.forEach((item,i)=>{
   const progress=clamp((innerHeight*.96-tops[i])/(innerHeight*.65)+(1-i%3)*.08);
   offsets[i]=(1-progress)*(45+20*(i%3));
   property(item,'--gallery-offset',`${number(offsets[i])}px`);
   property(item,'--gallery-scale',number(.94+.06*progress));
  }),
  reset:()=>items.forEach((item,i)=>{offsets[i]=0;clear(item,'--gallery-offset','--gallery-scale');})
 };
});

register('[data-cta-scene]',element=>({
 read:()=>element.getBoundingClientRect(),
 write:rect=>{const progress=entry(rect);property(element,'--cta-turn',`${number(-50*(1-progress))}deg`);property(element,'--cta-scale',number(.72+.28*progress));},
 reset:()=>clear(element,'--cta-turn','--cta-scale')
}));

register('[data-footer-scene]',element=>{
 const wordmark=element.querySelector('.one-footer__wordmark'),letters=[...element.querySelectorAll('[data-footer-letter]')];
 return {
  read:()=>wordmark?.getBoundingClientRect(),
  write:rect=>{
   if(!rect)return;
   const progress=clamp((innerHeight*.98-rect.top)/(rect.height+innerHeight*.08));
   letters.forEach((letter,i)=>property(letter,'--letter-rise',`${number((1-clamp(progress*1.5-i*.025))*90)}%`));
   property(element,'--footer-turn',`${number(-45*(1-progress))}deg`);
  },
  reset:()=>{letters.forEach(letter=>clear(letter,'--letter-rise'));clear(element,'--footer-turn');}
 };
});

register('[data-work-hall]',element=>{
 const cards=[...element.querySelectorAll('[data-work-card]')];
 return {
  read:()=>cards.map(card=>card.getBoundingClientRect()),
  write:rects=>rects.forEach((rect,i)=>{
   const progress=entry(rect);
   property(cards[i],'--work-inset',`${number((1-progress)*18)}%`);
   property(cards[i],'--work-angle',`${number((1-progress)*(i%2?14:-14))}deg`);
   property(cards[i],'--work-scale',number(.86+.14*progress));
  }),
  reset:()=>cards.forEach(card=>clear(card,'--work-inset','--work-angle','--work-scale'))
 };
});

register('.one-project-detail__hero-media',element=>({
 read:()=>element.getBoundingClientRect(),
 write:rect=>{const progress=entry(rect);property(element,'--project-radius',`${number(48-32*progress)}px`);property(element,'--project-scale',number(.94+.06*progress));},
 reset:()=>clear(element,'--project-radius','--project-scale')
}));

let frame=0;
const active=new Set();
const update=()=>{
 frame=0;
 if(!enabled())return;
 // Read every active scene first, then write: no alternating layout reads/writes.
 const measurements=[...active].map(scene=>[scene,scene.read()]);
 measurements.forEach(([scene,data])=>scene.write(data));
};
const schedule=()=>{if(!frame&&enabled())frame=requestAnimationFrame(update);};
const observer=new IntersectionObserver(entries=>{
 entries.forEach(entry=>{
  const scene=scenes.find(item=>item.element===entry.target);
  if(entry.isIntersecting)active.add(scene);else active.delete(scene);
 });
 schedule();
},{rootMargin:'180px 0px'});
scenes.forEach(scene=>observer.observe(scene.element));
addEventListener('scroll',schedule,{passive:true});
addEventListener('resize',schedule);
addEventListener('onestep:motion',()=>{
 cancelAnimationFrame(frame);frame=0;
 scenes.forEach(scene=>scene.reset());schedule();
});
document.fonts?.ready.then(schedule);
if(typeof ResizeObserver!=='undefined')new ResizeObserver(schedule).observe(document.body);
schedule();
